import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { NgxSpinnerService } from 'ngx-spinner';
//import { EmpFilter, filterOption } from '../model/empfilter';
import axios from 'axios';

@Component({
  selector: 'app-carcut-report',
  templateUrl: './carcut-report.component.html',
  styleUrls: ['./carcut-report.component.css']
})
export class CarcutReportComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  datagoup: UntypedFormGroup;
  constructor(private spinner: NgxSpinnerService) {

    this.datagoup = new UntypedFormGroup({
      szone: new UntypedFormControl(''),
      today: new UntypedFormControl(),
    });
  }

  ngOnInit(): void {
    this.LoadTruckdata();
    this.LoadZone();
  }
  @ViewChild('zonetruck', { static: false }) zonetruckTable: any;


  zonecode: any;
  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
      }).catch(err => { throw (err) })

  }

  displayedColumns = ['carcutId', 'carReg', 'fmname', 'groupCode', 'h_fmname', 'supzone', 'target_cane', 'sum_wgt', 'pc_sum_wgt', 'canCutMax', 'canPerDay', 'sum_wgt24h', 'pc_canPerDay', 'last_date', 'Hourlastcut', 'check_cut'];


  allcarCut: any;
  carCutT1: any;
  carCutT2: any;
  carCutT3: any;
  Dataalltruck: any;
  countdata: Array<number> = [0, 0, 0, 0];
  sumdata: Array<number> = [0, 0, 0, 0, 0];
  seleczone: string;



  LoadTruckdata() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbo].[v_carcut_report]&w=1=1 order by [last_date] desc";
    axios.get(url)
      .then(res => {
        let data = (res.data);
        if (data.length > 0) {
          this.allcarCut = data;
          this.carCutT1 = data.filter(el => el.check_cut == 1)
          this.carCutT2 = data.filter(el => el.check_cut == 2)
          this.carCutT3 = data.filter(el => el.check_cut == 3)
          this.countdata = [this.allcarCut.length, this.carCutT1.length, this.carCutT2.length, this.carCutT3.length]
          this.sumdata = [
            (data.map((el: any) => { return parseFloat(el.canCutMax) })).reduce((a, b) => a + b, 0),
            (data.map((el: any) => { return parseFloat(el.target_cane) })).reduce((a, b) => a + b, 0),
            (data.map((el: any) => { return parseFloat(el.sum_wgt) })).reduce((a, b) => a + b, 0),
            (data.map((el: any) => { return parseFloat(el.canPerDay) })).reduce((a, b) => a + b, 0),
            (data.map((el: any) => { return parseFloat(el.sum_wgt24h) })).reduce((a, b) => a + b, 0)
          ]
          this.setDataTeble(0);
          console.log('countdata', this.countdata);
          console.log('sumdata', this.sumdata);
        }
        /*setTimeout(() => {
          $(this.zonetruckTable.nativeElement).DataTable();
          }, 100);*/
      }).catch(err => { throw (err) })
    this.spinner.hide();
  }

  typec: string
  settap: number; txtTap: string

  setDataTeble(i = 0) {
    let dataintable
    let numf = 15
    let zcode = this.seleczone;//this.datagoup.get('szone').value;
    let ndData
    if (i == 0) {//all
      dataintable = this.allcarCut
      this.txtTap = 'รถตัดทั้งหมด';
      this.settap = i
    }
    else if (i == 1) {//
      dataintable = this.carCutT1
      this.txtTap = 'รถตัดที่ตัดปกติ';
      this.settap = i
    }
    else if (i == 2) {//
      dataintable = this.carCutT2
      this.txtTap = 'รถตัดที่ไม่ได้ตัด';
      this.settap = i
    }
    else if (i == 3) {//
      dataintable = this.carCutT3
      this.txtTap = 'รถตัดที่เสีย';
      this.settap = i
    }
    else if (i == 10) {//
      if (this.settap == 0) ndData = this.allcarCut;
      else if (this.settap == 1) ndData = this.carCutT1;
      else if (this.settap == 2) ndData = this.carCutT2;
      else if (this.settap == 3) ndData = this.carCutT3;
      /// -------------
      if (zcode.substring(0, 1) == 'P') {
        dataintable = ndData.filter((el: any) => el.Partcode === zcode);
      }
      else if (zcode === 'All') {
        dataintable = ndData;
      }
      else {
        dataintable = ndData.filter((el: any) => el.supzone === zcode);
      }

      //this.txtTap = 'อิงตามกลุ่มตัด';
      numf = dataintable.length;
    }

    if (dataintable != null) {
      this.Dataalltruck = new MatTableDataSource(dataintable);
      this.paginator.length = dataintable.length;
      this.paginator.pageSize = numf;
      this.Dataalltruck.paginator = this.paginator;
      this.Dataalltruck.sort = this.sort;
      // console.log(this.allcarCut);

    }
    console.log('data', i, dataintable.length);

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.Dataalltruck.filter = filterValue.trim().toLowerCase();
    if (this.Dataalltruck.paginator) {
      this.Dataalltruck.paginator.firstPage();
    }
  }
  zoneFilter(zone: string) {
    const filterValue = zone
    this.Dataalltruck.filter.supzone = filterValue.trim();
    if (this.Dataalltruck.paginator) {
      this.Dataalltruck.paginator.firstPage();
    }
    //.filter(el => el.check_cut == 1)
  }

}
